import { TbMathSymbols } from "react-icons/tb";
import { FiUser, FiUsers } from "react-icons/fi";
import { RiBuilding4Line } from "react-icons/ri";
import { BsLinkedin, BsTwitter } from "react-icons/bs";

interface FooterLink {
  label: string;
  type: "internal" | "external";
  to?: string;
  href?: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

export const sublinks = [
  {
    label: "Private Project Owners",
    link: "/owner",
    icon: FiUser,
    iconbg: "bg-[#ECF2FB]",
    iconcolor: "#437ADB",
    description:
      "Get end-to-end project procurement that optimizes speed and quality at the right price.",
  },
  {
    label: "Enterprise Project Owners",
    link: "/enterprise",
    icon: RiBuilding4Line,
    iconbg: "bg-[#FFF3EB]",
    iconcolor: "#FF8A34",
    description:
      "Access the tools to deliver satisfaction to every client, every time.",
  },
  {
    label: "Build Now Pay Later",
    link: "/finance",
    icon: RiBuilding4Line,
    iconbg: "bg-[#F6E8ED]",
    iconcolor: "#A7194B",
    description:
      "Access the tools to deliver satisfaction to every client, every time.",
  },

  {
    label: "Contractor",
    link: "/contractor",
    icon: FiUsers,
    iconbg: "bg-[#E9F6F2]",
    iconcolor: "#26A87D",
    description:
      "Gain access to bid on an endless pool of new projects at the speed of a click",
  },
  {
    label: "Consultant",
    link: "/consultant",
    icon: FiUsers,
    iconbg: "bg-[#E9F6F2]",
    iconcolor: "#26A87D",
    description:
      "Gain access to bid on an endless pool of new projects at the speed of a click",
  },

  // {
  //     label: "Doctors",
  //     link: "/doctor",
  //     icon: FiUsers,
  //     iconbg: "bg-[#E9F6F2]",
  //     iconcolor: "#26A87D",
  //     description:
  //         "Access the tools to deliver satisfaction to every client, every time.",
  // },
];
// export const pricingSublinks = [
// 	{
// 		label: "Normal Price",
// 		link: "/pricing/normal",
// 		icon: FiUser,
// 		iconbg: "bg-[#ECF2FB]",
// 		iconcolor: "#437ADB",
// 		description:
// 			"Get end-to-end project procurement that optimizes speed and quality at the right price.",
// 	},
// 	{
// 		label: "Premium Price",
// 		link: "/pricing/premium",
// 		icon: RiBuilding4Line,
// 		iconbg: "bg-[#FFF3EB]",
// 		iconcolor: "#FF8A34",
// 		description:
// 			"Access the tools to deliver satisfaction to every client, every time.",
// 	},

// ];

export const footerSections: FooterSection[] = [
  {
    title: "PRODUCTS",
    links: [
      { label: "For Lenders", to: "/lender", type: "internal" },
      { label: "For Property Owners", to: "/owner", type: "internal" },
      { label: "For Property Developer", to: "/developer", type: "internal" },
      { label: "For Contractors", to: "/contractor", type: "internal" },
      { label: "For Consultants", to: "/consultant", type: "internal" },
    ],
  },
  {
    title: "SOCIAL MEDIA",
    links: [
      {
        label: "Twitter",
        href: "//www.twitter.com/usebnkle",
        type: "external",
      },
      {
        label: "Linkedin",
        href: "//www.linkedin.com/company/bnklé/",
        type: "external",
      },
    ],
  },
  {
    title: "LINKS",
    links: [
      {
        label: "Cost Calculator",
        href: `https://calculator.${process.env.REACT_APP_DOMAIN}`,
        type: "external",
      },
      {
        label: "Privacy Policy",
        to: "/policy",
        type: "internal",
      },
      {
        label: "Terms of Use",
        to: "/terms",
        type: "internal",
      },
      {
        label: "Support",
        to: "/support",
        type: "internal",
      },
    ],
  },
];
